"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgoraTranslate = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const agora_rtc_sdk_ng_1 = require("agora-rtc-sdk-ng");
const AgoraConsole_1 = require("./AgoraConsole");
class AgoraTranslate {
    static NATIVE_RTCLOG_LEVEL2Number(logLevel) {
        switch (logLevel) {
            case NATIVE_RTC.LOG_LEVEL.LOG_LEVEL_NONE:
                return 4;
            case NATIVE_RTC.LOG_LEVEL.LOG_LEVEL_INFO:
                return 1;
            case NATIVE_RTC.LOG_LEVEL.LOG_LEVEL_WARN:
                return 2;
            case NATIVE_RTC.LOG_LEVEL.LOG_LEVEL_ERROR:
                return 3;
            case NATIVE_RTC.LOG_LEVEL.LOG_LEVEL_FATAL:
                return 3;
            case NATIVE_RTC.LOG_LEVEL.LOG_LEVEL_API_CALL:
                return 0;
            default:
                AgoraConsole_1.AgoraConsole.log('SDK logLevel is not specified, will output webSDK log.');
                return 0;
        }
    }
    static NATIVE_RTCAREA_CODE2AREAS(areaCode) {
        switch (areaCode) {
            case NATIVE_RTC.AREA_CODE.AREA_CODE_CN:
                return agora_rtc_sdk_ng_1.AREAS.CHINA;
            case NATIVE_RTC.AREA_CODE.AREA_CODE_NA:
                return agora_rtc_sdk_ng_1.AREAS.NORTH_AMERICA;
            case NATIVE_RTC.AREA_CODE.AREA_CODE_EU:
                return agora_rtc_sdk_ng_1.AREAS.EUROPE;
            case NATIVE_RTC.AREA_CODE.AREA_CODE_AS:
                return agora_rtc_sdk_ng_1.AREAS.ASIA;
            case NATIVE_RTC.AREA_CODE.AREA_CODE_JP:
                return agora_rtc_sdk_ng_1.AREAS.JAPAN;
            case NATIVE_RTC.AREA_CODE.AREA_CODE_IN:
                return agora_rtc_sdk_ng_1.AREAS.INDIA;
            case NATIVE_RTC.AREA_CODE.AREA_CODE_GLOB:
                return agora_rtc_sdk_ng_1.AREAS.GLOBAL;
            case NATIVE_RTC.AREA_CODE_EX.AREA_CODE_SA:
                return agora_rtc_sdk_ng_1.AREAS.SOUTH_AMERICA;
            case NATIVE_RTC.AREA_CODE_EX.AREA_CODE_AF:
                return agora_rtc_sdk_ng_1.AREAS.AFRICA;
            case NATIVE_RTC.AREA_CODE_EX.AREA_CODE_KR:
                return agora_rtc_sdk_ng_1.AREAS.KOREA;
            case NATIVE_RTC.AREA_CODE_EX.AREA_CODE_OC:
                return agora_rtc_sdk_ng_1.AREAS.OCEANIA;
            case NATIVE_RTC.AREA_CODE_EX.AREA_CODE_HKMC:
                return agora_rtc_sdk_ng_1.AREAS.HKMC;
            case NATIVE_RTC.AREA_CODE_EX.AREA_CODE_US:
                return agora_rtc_sdk_ng_1.AREAS.US;
            case NATIVE_RTC.AREA_CODE_EX.AREA_CODE_OVS:
                return agora_rtc_sdk_ng_1.AREAS.OVERSEA;
            default:
                AgoraConsole_1.AgoraConsole.warn('input Unknown areaCode');
                return agora_rtc_sdk_ng_1.AREAS.GLOBAL;
        }
    }
    static NATIVE_RTC_CLIENT_ROLE_TYPE2ClientRole(clientRole) {
        switch (clientRole) {
            case NATIVE_RTC.CLIENT_ROLE_TYPE.CLIENT_ROLE_BROADCASTER:
                return 'host';
            case NATIVE_RTC.CLIENT_ROLE_TYPE.CLIENT_ROLE_AUDIENCE:
                return 'audience';
        }
    }
    static NATIVE_RTC_CHANNEL_PROFILE_TYPE2SDK_MODE(channelProfile) {
        switch (channelProfile) {
            case NATIVE_RTC.CHANNEL_PROFILE_TYPE.CHANNEL_PROFILE_LIVE_BROADCASTING:
                return 'live';
            default:
                return 'rtc';
        }
    }
    static NATIVE_RTCClientRoleOptions2ClientRoleOptions(options) {
        switch (options.audienceLatencyLevel) {
            case NATIVE_RTC.AUDIENCE_LATENCY_LEVEL_TYPE
                .AUDIENCE_LATENCY_LEVEL_LOW_LATENCY:
                return { level: agora_rtc_sdk_ng_1.AudienceLatencyLevelType.AUDIENCE_LEVEL_LOW_LATENCY };
            case NATIVE_RTC.AUDIENCE_LATENCY_LEVEL_TYPE
                .AUDIENCE_LATENCY_LEVEL_ULTRA_LOW_LATENCY:
                return {
                    level: agora_rtc_sdk_ng_1.AudienceLatencyLevelType.AUDIENCE_LEVEL_ULTRA_LOW_LATENCY,
                };
            default:
                return {
                    level: agora_rtc_sdk_ng_1.AudienceLatencyLevelType.AUDIENCE_LEVEL_ULTRA_LOW_LATENCY,
                };
        }
    }
    static NATIVE_RTC_AUDIENCE_LATENCY_LEVEL_TYPE2ClientRoleOptions(level) {
        switch (level) {
            case NATIVE_RTC.AUDIENCE_LATENCY_LEVEL_TYPE
                .AUDIENCE_LATENCY_LEVEL_LOW_LATENCY:
                return { level: agora_rtc_sdk_ng_1.AudienceLatencyLevelType.AUDIENCE_LEVEL_LOW_LATENCY };
            case NATIVE_RTC.AUDIENCE_LATENCY_LEVEL_TYPE
                .AUDIENCE_LATENCY_LEVEL_ULTRA_LOW_LATENCY:
                return {
                    level: agora_rtc_sdk_ng_1.AudienceLatencyLevelType.AUDIENCE_LEVEL_ULTRA_LOW_LATENCY,
                };
            default:
                return {
                    level: agora_rtc_sdk_ng_1.AudienceLatencyLevelType.AUDIENCE_LEVEL_ULTRA_LOW_LATENCY,
                };
        }
    }
    static NATIVE_RTCVideoEncoderConfiguration2VideoEncoderConfiguration(conf) {
        var _a, _b;
        return {
            width: (_a = conf.dimensions) === null || _a === void 0 ? void 0 : _a.width,
            height: (_b = conf.dimensions) === null || _b === void 0 ? void 0 : _b.height,
            frameRate: conf.frameRate,
            bitrateMax: conf.bitrate,
            bitrateMin: conf.minBitrate,
        };
    }
    static NATIVE_RTCVideoFormat2VideoEncoderConfiguration(videoFormat) {
        let ret = {
            width: videoFormat.width,
            height: videoFormat.height,
            frameRate: videoFormat.fps,
        };
        return ret;
    }
    static NATIVE_RTCScreenCaptureParameters2VideoEncoderConfiguration(conf) {
        var _a, _b;
        let ret = {
            frameRate: (_a = conf.videoParams) === null || _a === void 0 ? void 0 : _a.frameRate,
            bitrateMax: (_b = conf.videoParams) === null || _b === void 0 ? void 0 : _b.bitrate,
        };
        return ret;
    }
    static NATIVE_RTCSimulcastStreamConfig2LowStreamParameter(config) {
        let width = config.dimensions ? config.dimensions.width : 0;
        let height = config.dimensions ? config.dimensions.height : 0;
        let ret = {
            width: width,
            height: height,
            framerate: {
                ideal: config.framerate,
            },
            bitrate: config.framerate,
        };
        return ret;
    }
    static NATIVE_RTCCONNECTION_STATE_TYPE2ConnectionState(state) {
        switch (state) {
            case NATIVE_RTC.CONNECTION_STATE_TYPE.CONNECTION_STATE_DISCONNECTED:
                return 'DISCONNECTED';
            case NATIVE_RTC.CONNECTION_STATE_TYPE.CONNECTION_STATE_CONNECTING:
                return 'CONNECTING';
            case NATIVE_RTC.CONNECTION_STATE_TYPE.CONNECTION_STATE_CONNECTED:
                return 'CONNECTED';
            case NATIVE_RTC.CONNECTION_STATE_TYPE.CONNECTION_STATE_RECONNECTING:
                return 'RECONNECTING';
            case NATIVE_RTC.CONNECTION_STATE_TYPE.CONNECTION_STATE_FAILED:
                return 'DISCONNECTED';
        }
    }
    static NATIVE_RTCENCRYPTION_MODE2EncryptionMode(mode) {
        switch (mode) {
            case NATIVE_RTC.ENCRYPTION_MODE.AES_128_XTS:
                return 'aes-128-xts';
            case NATIVE_RTC.ENCRYPTION_MODE.AES_128_ECB:
                return 'aes-128-ecb';
            case NATIVE_RTC.ENCRYPTION_MODE.AES_256_XTS:
                return 'aes-256-xts';
            case NATIVE_RTC.ENCRYPTION_MODE.SM4_128_ECB:
                return 'sm4-128-ecb';
            case NATIVE_RTC.ENCRYPTION_MODE.AES_128_GCM:
                return 'aes-128-gcm';
            case NATIVE_RTC.ENCRYPTION_MODE.AES_256_GCM:
                return 'aes-256-gcm';
            case NATIVE_RTC.ENCRYPTION_MODE.AES_128_GCM2:
                return 'aes-128-gcm2';
            case NATIVE_RTC.ENCRYPTION_MODE.AES_256_GCM2:
                return 'aes-256-gcm2';
            default:
                return 'none';
        }
    }
    static NATIVE_RTCContentInspectConfig2InspectConfiguration(config) {
        var _a;
        let defaultInterval = 1;
        let ret = {
            interval: defaultInterval,
            extraInfo: config.extraInfo,
            inspectType: [],
        };
        let module = config.modules
            ? config.modules[0]
            : {
                type: NATIVE_RTC.CONTENT_INSPECT_TYPE.CONTENT_INSPECT_MODERATION,
                interval: defaultInterval,
            };
        ret.interval = (_a = module.interval) !== null && _a !== void 0 ? _a : defaultInterval;
        switch (module.type) {
            case NATIVE_RTC.CONTENT_INSPECT_TYPE.CONTENT_INSPECT_INVALID:
                break;
            case NATIVE_RTC.CONTENT_INSPECT_TYPE.CONTENT_INSPECT_MODERATION:
                ret.inspectType.push('moderation');
                break;
            case NATIVE_RTC.CONTENT_INSPECT_TYPE.CONTENT_INSPECT_SUPERVISION:
                ret.inspectType.push('supervise');
                break;
        }
        //web这里的单位是毫秒， 而native传入的间隔是秒
        ret.interval = module.interval
            ? module.interval * 1000
            : defaultInterval * 1000;
        return ret;
    }
    static NATIVE_RTCVIDEO_CONTENT_HINT2string(hint) {
        switch (hint) {
            case NATIVE_RTC.VIDEO_CONTENT_HINT.CONTENT_HINT_MOTION:
                return 'motion';
            case NATIVE_RTC.VIDEO_CONTENT_HINT.CONTENT_HINT_DETAILS:
                return 'detail';
            default:
                return 'detail';
        }
    }
    static NATIVE_RTCCAMERA_DIRECTION2string(direction) {
        switch (direction) {
            case NATIVE_RTC.CAMERA_DIRECTION.CAMERA_FRONT:
                return 'user';
            case NATIVE_RTC.CAMERA_DIRECTION.CAMERA_REAR:
                return 'environment';
        }
    }
    static NATIVE_RTCVIDEO_MIRROR_MODE_TYPE2boolean(mode) {
        switch (mode) {
            case NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_AUTO:
                return true;
            case NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_DISABLED:
                return false;
            case NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_ENABLED:
                return true;
        }
    }
    static NATIVE_RTCVIDEO_CODEC_TYPE2SDK_CODEC(code) {
        switch (code) {
            case NATIVE_RTC.VIDEO_CODEC_TYPE.VIDEO_CODEC_H264:
                return 'h264';
            case NATIVE_RTC.VIDEO_CODEC_TYPE.VIDEO_CODEC_AV1:
                return 'av1';
            case NATIVE_RTC.VIDEO_CODEC_TYPE.VIDEO_CODEC_VP8:
                return 'vp8';
            case NATIVE_RTC.VIDEO_CODEC_TYPE.VIDEO_CODEC_VP9:
                return 'vp9';
            default:
                return 'vp8';
        }
    }
    static NATIVE_RTCVIDEO_STREAM_TYPE2RemoteStreamType(type) {
        switch (type) {
            case NATIVE_RTC.VIDEO_STREAM_TYPE.VIDEO_STREAM_HIGH:
                return agora_rtc_sdk_ng_1.RemoteStreamType.HIGH_STREAM;
            case NATIVE_RTC.VIDEO_STREAM_TYPE.VIDEO_STREAM_LOW:
                return agora_rtc_sdk_ng_1.RemoteStreamType.LOW_STREAM;
            default:
                return agora_rtc_sdk_ng_1.RemoteStreamType.HIGH_STREAM;
        }
    }
    static NATIVE_RTCSTREAM_FALLBACK_OPTIONS2RemoteStreamFallbackType(fallback) {
        switch (fallback) {
            case NATIVE_RTC.STREAM_FALLBACK_OPTIONS.STREAM_FALLBACK_OPTION_DISABLED:
                return agora_rtc_sdk_ng_1.RemoteStreamFallbackType.DISABLE;
            case NATIVE_RTC.STREAM_FALLBACK_OPTIONS
                .STREAM_FALLBACK_OPTION_VIDEO_STREAM_LOW:
                return agora_rtc_sdk_ng_1.RemoteStreamFallbackType.LOW_STREAM;
            case NATIVE_RTC.STREAM_FALLBACK_OPTIONS.STREAM_FALLBACK_OPTION_AUDIO_ONLY:
                return agora_rtc_sdk_ng_1.RemoteStreamFallbackType.AUDIO_ONLY;
            default:
                return agora_rtc_sdk_ng_1.RemoteStreamFallbackType.DISABLE;
        }
    }
    static NATIVE_RTCTranscodingUser2LiveStreamingTranscodingUser(user) {
        let ret = {
            alpha: user.alpha,
            height: user.height,
            uid: user.uid,
            width: user.width,
            x: user.x,
            y: user.y,
            zOrder: user.zOrder,
            audioChannel: user.audioChannel,
        };
        return ret;
    }
    /*************************/
    static DeviceState2NATIVE_RTCMEDIA_DEVICE_STATE_TYPE(state) {
        switch (state) {
            case 'ACTIVE':
                return NATIVE_RTC.MEDIA_DEVICE_STATE_TYPE.MEDIA_DEVICE_STATE_ACTIVE;
            case 'INACTIVE':
                return NATIVE_RTC.MEDIA_DEVICE_STATE_TYPE.MEDIA_DEVICE_STATE_DISABLED;
        }
    }
    static ConnectionState2NATIVE_RTCCONNECTION_STATE_TYPE(state) {
        switch (state) {
            case 'DISCONNECTED':
                return NATIVE_RTC.CONNECTION_STATE_TYPE.CONNECTION_STATE_DISCONNECTED;
            case 'CONNECTING':
                return NATIVE_RTC.CONNECTION_STATE_TYPE.CONNECTION_STATE_CONNECTING;
            case 'CONNECTED':
                return NATIVE_RTC.CONNECTION_STATE_TYPE.CONNECTION_STATE_CONNECTED;
            case 'RECONNECTING':
                return NATIVE_RTC.CONNECTION_STATE_TYPE.CONNECTION_STATE_RECONNECTING;
            case 'DISCONNECTING':
                return NATIVE_RTC.CONNECTION_STATE_TYPE.CONNECTION_STATE_DISCONNECTED;
        }
    }
    static string2NATIVE_RTCENCRYPTION_MODE(mode) {
        switch (mode) {
            case 'aes-128-xts':
                return NATIVE_RTC.ENCRYPTION_MODE.AES_128_XTS;
            case 'aes-128-ecb':
                return NATIVE_RTC.ENCRYPTION_MODE.AES_128_ECB;
            case 'aes-256-xts':
                return NATIVE_RTC.ENCRYPTION_MODE.AES_256_XTS;
            case 'sm4-128-ecb':
                return NATIVE_RTC.ENCRYPTION_MODE.SM4_128_ECB;
            case 'aes-128-gcm':
                return NATIVE_RTC.ENCRYPTION_MODE.AES_128_GCM;
            case 'aes-256-gcm':
                return NATIVE_RTC.ENCRYPTION_MODE.AES_256_GCM;
            case 'aes-128-gcm2':
                return NATIVE_RTC.ENCRYPTION_MODE.AES_128_GCM2;
            case 'aes-256-gcm2':
                return NATIVE_RTC.ENCRYPTION_MODE.AES_256_GCM2;
            default:
                AgoraConsole_1.AgoraConsole.warn('invalid mode: ' + mode);
                return NATIVE_RTC.ENCRYPTION_MODE.AES_128_GCM;
        }
    }
    static ConnectionDisconnectedReason2NATIVE_RTCCONNECTION_CHANGED_REASON_TYPE(reason) {
        switch (reason) {
            case agora_rtc_sdk_ng_1.ConnectionDisconnectedReason.LEAVE:
                return NATIVE_RTC.CONNECTION_CHANGED_REASON_TYPE
                    .CONNECTION_CHANGED_LEAVE_CHANNEL;
            case agora_rtc_sdk_ng_1.ConnectionDisconnectedReason.NETWORK_ERROR:
                return NATIVE_RTC.CONNECTION_CHANGED_REASON_TYPE
                    .CONNECTION_CHANGED_INTERRUPTED;
            case agora_rtc_sdk_ng_1.ConnectionDisconnectedReason.SERVER_ERROR:
                return NATIVE_RTC.CONNECTION_CHANGED_REASON_TYPE
                    .CONNECTION_CHANGED_INTERRUPTED;
            case agora_rtc_sdk_ng_1.ConnectionDisconnectedReason.UID_BANNED:
                return NATIVE_RTC.CONNECTION_CHANGED_REASON_TYPE
                    .CONNECTION_CHANGED_BANNED_BY_SERVER;
            case agora_rtc_sdk_ng_1.ConnectionDisconnectedReason.IP_BANNED:
                return NATIVE_RTC.CONNECTION_CHANGED_REASON_TYPE
                    .CONNECTION_CHANGED_BANNED_BY_SERVER;
            case agora_rtc_sdk_ng_1.ConnectionDisconnectedReason.CHANNEL_BANNED:
                return NATIVE_RTC.CONNECTION_CHANGED_REASON_TYPE
                    .CONNECTION_CHANGED_INVALID_CHANNEL_NAME;
            case agora_rtc_sdk_ng_1.ConnectionDisconnectedReason.FALLBACK:
                return NATIVE_RTC.CONNECTION_CHANGED_REASON_TYPE
                    .CONNECTION_CHANGED_INTERRUPTED;
            default:
                return NATIVE_RTC.CONNECTION_CHANGED_REASON_TYPE
                    .CONNECTION_CHANGED_INTERRUPTED;
        }
    }
    static string2NATIVE_RTCUSER_OFFLINE_REASON_TYPE(reason) {
        switch (reason) {
            case 'Quit':
                return NATIVE_RTC.USER_OFFLINE_REASON_TYPE.USER_OFFLINE_QUIT;
            case 'ServerTimeOut':
                return NATIVE_RTC.USER_OFFLINE_REASON_TYPE.USER_OFFLINE_DROPPED;
            case 'BecomeAudience':
                return NATIVE_RTC.USER_OFFLINE_REASON_TYPE.USER_OFFLINE_BECOME_AUDIENCE;
            default:
                return NATIVE_RTC.USER_OFFLINE_REASON_TYPE.USER_OFFLINE_QUIT;
        }
    }
    static ChannelMediaRelayError2NATIVE_RTCCHANNEL_MEDIA_RELAY_ERROR(err) {
        switch (err) {
            case agora_rtc_sdk_ng_1.ChannelMediaRelayError.RELAY_OK:
                return NATIVE_RTC.CHANNEL_MEDIA_RELAY_ERROR.RELAY_OK;
            case agora_rtc_sdk_ng_1.ChannelMediaRelayError.SERVER_CONNECTION_LOST:
                return NATIVE_RTC.CHANNEL_MEDIA_RELAY_ERROR
                    .RELAY_ERROR_SERVER_CONNECTION_LOST;
            case agora_rtc_sdk_ng_1.ChannelMediaRelayError.SRC_TOKEN_EXPIRED:
                return NATIVE_RTC.CHANNEL_MEDIA_RELAY_ERROR
                    .RELAY_ERROR_SRC_TOKEN_EXPIRED;
            case agora_rtc_sdk_ng_1.ChannelMediaRelayError.DEST_TOKEN_EXPIRED:
                return NATIVE_RTC.CHANNEL_MEDIA_RELAY_ERROR
                    .RELAY_ERROR_DEST_TOKEN_EXPIRED;
        }
    }
    static volumeIndicatorResult2NATIVE_RTCAudioVolumeInfo(result) {
        //level范围是[0,100], volume范围是 0 - 255， 要做一下转换
        let audioVolumInfo = {
            uid: result.uid,
            volume: Math.floor(result.level * 2.55),
            vad: 0,
            voicePitch: 0,
        };
        return audioVolumInfo;
    }
    //webQuality
    //webQuality:    6,5,4,3,2,1   poor=>better
    //agortcQuality: 0,1,2,3,4,5,  poor=>better
    static webQuality2NATIVE_RTCQuality(webQuality) {
        return 6 - webQuality;
    }
    static data2NATIVE_RTC_CONNECT_INSPECT_RESULT(data) {
        switch (data) {
            case 'porn':
                return NATIVE_RTC.CONTENT_INSPECT_RESULT.CONTENT_INSPECT_PORN;
            case 'sexy':
                return NATIVE_RTC.CONTENT_INSPECT_RESULT.CONTENT_INSPECT_SEXY;
            case 'neutral':
                return NATIVE_RTC.CONTENT_INSPECT_RESULT.CONTENT_INSPECT_NEUTRAL;
        }
    }
    static NATIVE_RTC_RENDER_MODE_TYPE2Fit(renderMode) {
        switch (renderMode) {
            case NATIVE_RTC.RENDER_MODE_TYPE.RENDER_MODE_ADAPTIVE:
                return 'cover';
            case NATIVE_RTC.RENDER_MODE_TYPE.RENDER_MODE_FIT:
                return 'contain';
            case NATIVE_RTC.RENDER_MODE_TYPE.RENDER_MODE_HIDDEN:
                return 'cover';
            default:
                return 'fill';
        }
    }
    static NATIVE_RTC_VIDEO_STREAM_TYPE2Number(type) {
        switch (type) {
            case NATIVE_RTC.VIDEO_STREAM_TYPE.VIDEO_STREAM_HIGH:
                return agora_rtc_sdk_ng_1.RemoteStreamType.HIGH_STREAM;
            case NATIVE_RTC.VIDEO_STREAM_TYPE.VIDEO_STREAM_LOW:
                return agora_rtc_sdk_ng_1.RemoteStreamType.LOW_STREAM;
            case NATIVE_RTC.VIDEO_STREAM_TYPE.VIDEO_STREAM_LAYER_1:
                return agora_rtc_sdk_ng_1.RemoteStreamType.HIGH_STREAM_LAYER1;
            case NATIVE_RTC.VIDEO_STREAM_TYPE.VIDEO_STREAM_LAYER_2:
                return agora_rtc_sdk_ng_1.RemoteStreamType.HIGH_STREAM_LAYER2;
            case NATIVE_RTC.VIDEO_STREAM_TYPE.VIDEO_STREAM_LAYER_3:
                return agora_rtc_sdk_ng_1.RemoteStreamType.HIGH_STREAM_LAYER3;
            case NATIVE_RTC.VIDEO_STREAM_TYPE.VIDEO_STREAM_LAYER_4:
                return agora_rtc_sdk_ng_1.RemoteStreamType.HIGH_STREAM_LAYER4;
            case NATIVE_RTC.VIDEO_STREAM_TYPE.VIDEO_STREAM_LAYER_5:
                return agora_rtc_sdk_ng_1.RemoteStreamType.HIGH_STREAM_LAYER5;
            case NATIVE_RTC.VIDEO_STREAM_TYPE.VIDEO_STREAM_LAYER_6:
                return agora_rtc_sdk_ng_1.RemoteStreamType.HIGH_STREAM_LAYER6;
            default:
                return agora_rtc_sdk_ng_1.RemoteStreamType.HIGH_STREAM;
        }
    }
}
exports.AgoraTranslate = AgoraTranslate;
